import { useState } from "react";
import Sheet from "./Sheet";

export interface SelectOption {
  value: string;
  label: string;
  sub?: string;
  trailing?: string;
}

interface SelectSheetProps {
  value: string;
  options: SelectOption[];
  placeholder: string;
  title?: string;
  onChange: (value: string) => void;
}

export default function SelectSheet({
  value,
  options,
  placeholder,
  title = "Selecciona una opción",
  onChange,
}: SelectSheetProps) {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex w-full items-center justify-between gap-2 rounded-2xl border border-background-200 bg-background-50 px-4 py-3 text-left active:scale-[0.99]"
      >
        <span className="flex min-w-0 flex-col">
          {selected ? (
            <>
              <span className="truncate text-[15px] text-foreground-950">{selected.label}</span>
              {selected.sub ? (
                <span className="truncate text-[11px] text-foreground-500">{selected.sub}</span>
              ) : null}
            </>
          ) : (
            <span className="text-[15px] text-foreground-400">{placeholder}</span>
          )}
        </span>
        <i className="ri-arrow-down-s-line flex-none text-lg text-foreground-400" />
      </button>

      <Sheet open={open} onClose={() => setOpen(false)} title={title}>
        <div className="space-y-2 pb-4">
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between gap-3 rounded-2xl border px-4 py-3 text-left transition-colors ${
                opt.value === value
                  ? "border-primary-400 bg-primary-50"
                  : "border-background-200 bg-background-50"
              }`}
            >
              <span className="flex min-w-0 flex-col">
                <span className="truncate text-[14px] font-medium text-foreground-900">
                  {opt.label}
                </span>
                {opt.sub ? (
                  <span className="truncate text-[11px] text-foreground-500">{opt.sub}</span>
                ) : null}
              </span>
              <span className="flex flex-none items-center gap-2">
                {opt.trailing ? (
                  <span className="tabular-nums text-[12px] text-foreground-500">{opt.trailing}</span>
                ) : null}
                {opt.value === value ? (
                  <i className="ri-check-line text-lg text-primary-600" />
                ) : null}
              </span>
            </button>
          ))}
        </div>
      </Sheet>
    </>
  );
}